export default __webpack_public_path__ + "static/media/corporate3.b9366e97.jpg";